<template>
  <div>
    <div class="position-relative mb-3">
      <div class="position-relative mb-3">
        <section class="section-profile-cover section-shaped my-0">
          <div class="shape shape-style-1 shape-yellowdark shape-skew alpha-4">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </section>
        <section class="section-skew">
          <div class="container-section">
            <card shadow class="section-home">
              <div class="row row-grid align-items-center">
                <div
                  class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 text-right"
                >
                  <div class="title-product">
                    <h3>
                      محصولات ما
                    </h3>
                    <p>
                      تمامی محصولات مجموعه سرمد، با قابلیت شخصی‌سازی کامل،
                      به‌طور خاص برای برآورده کردن نیازهای منحصر به فرد کسب‌وکار
                      شما طراحی می‌شوند. با این راه‌حل‌های ویژه، می‌توانید
                      بهره‌وری و سودآوری خود را به اوج برسانید و به آسانی از
                      پتانسیل کامل کسب‌وکار خود بهره‌مند شوید.
                    </p>
                    <base-button
                      type="navyDark"
                      round
                      block
                      size="md"
                      @click="scrollToProduct"
                    >
                      مشاهده محصولات
                    </base-button>
                  </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                  <div class="img-main-page">
                    <img src="img/product/Devices-pana.svg" alt="" />
                  </div>
                </div>
              </div>
            </card>
          </div>
        </section>
      </div>
    </div>
    <section ref="productSection">
      <div class="container-section">
        <div class="box-items-help">
          <b-row>
            <b-col
              cols="12"
              xl="4"
              lg="6"
              md="6"
              sm="12"
              xs="12"
              :class="[
                'box-card-product',
                cardVisible[0] ? 'visible' : 'hidden',
              ]"
              @click="navigateToSatrapp"
            >
              <card class="shadow-lg--hover card-product">
                <b-col cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
                  <div class="img-product">
                    <img src="img/product/Dashboard.svg" />
                  </div>
                </b-col>
                <b-col cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
                  <div class="text-product">
                    <h5>مدیریت پروژه ساتراپ</h5>
                    <span>
                      ساتراپ، داشبورد جامع مدیریت سازمانی سامانه مدیریتی ساتراپ،
                      با ترکیب قدرت و هوشمندی، شما را قادر می‌سازد تا با یک نگاه
                      جامع، سازمان خود را بهینه کرده و به سوی رشد و موفقیت حرکت
                      نمایید.
                    </span>
                    <p @click.stop="navigateToSatrapp">مشاهده بیشتر</p>
                  </div>
                </b-col>
              </card>
            </b-col>
            <b-col
              cols="12"
              xl="4"
              lg="6"
              md="6"
              sm="12"
              xs="12"
              :class="[
                'box-card-product',
                cardVisible[1] ? 'visible' : 'hidden',
              ]"
              @click="navigateToCrm"
            >
              <card class="shadow-lg--hover card-product">
                <b-col cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
                  <div class="img-product">
                    <img src="img/product/management-pana.svg" />
                  </div>
                </b-col>
                <b-col cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
                  <div class="text-product">
                    <h5>مدیریت ارتباط با مشتری (CRM) و باشگاه مشتریان</h5>
                    <span>
                      مدیریت ارتباط با مشتریان کسب و کار خود را در بالاترین سطح
                      تجربه کنید!
                    </span>
                    <p @click="navigateToCrm">مشاهده بیشتر</p>
                  </div>
                </b-col>
              </card>
            </b-col>
            <b-col
              cols="12"
              xl="4"
              lg="6"
              md="6"
              sm="12"
              xs="12"
              :class="[
                'box-card-product',
                cardVisible[2] ? 'visible' : 'hidden',
              ]"
              @click="navigateToLMS"
            >
              <card class="shadow-lg--hover card-product">
                <b-col cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
                  <div class="img-product">
                    <img src="img/product/Trends-amico.svg" />
                  </div>
                </b-col>
                <b-col cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
                  <div class="text-product">
                    <h5>مدیریت آموزش (LMS) ساتراپ</h5>
                    <span>
                      سیستم مدیریت یادگیری (LMS) ساتراپ سرمد یک نرم افزار یا
                      فناوری مبتنی بر وب است که برای برنامه ریزی‌، پیاده سازی و
                      ارزیابی فرایندهای یادگیری استفاده می‌شود.
                    </span>
                    <p @click="navigateToLMS">مشاهده بیشتر</p>
                  </div>
                </b-col>
              </card>
            </b-col>
            <b-col
              cols="12"
              xl="4"
              lg="6"
              md="6"
              sm="12"
              xs="12"
              :class="[
                'box-card-product',
                cardVisible[3] ? 'visible' : 'hidden',
              ]"
              @click="navigateToTotia"
            >
              <card class="shadow-lg--hover card-product">
                <b-col cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
                  <div class="img-product">
                    <img src="img/product/Medicine-bro.svg" />
                  </div>
                </b-col>
                <b-col cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
                  <div class="text-product">
                    <h5>مدیریت کلینیک توتیاطب</h5>
                    <span>
                      توتیا طب یک سیستم مدیریت بیمارستانی، یک سیستم کامپیوتری
                      است که به مدیریت اطلاعات مربوط به مراکز و مجموعه‌های
                      درمانی کمک می‌کند و به طور موثر در تکمیل فرایند‌های کاری
                      ارائه دهندگان خدمات درمانی کمک می‌کند.
                    </span>
                    <p @click="navigateToTotia">مشاهده بیشتر</p>
                  </div>
                </b-col>
              </card>
            </b-col>
            <b-col
              cols="12"
              xl="4"
              lg="6"
              md="6"
              sm="12"
              xs="12"
              :class="[
                'box-card-product',
                cardVisible[4] ? 'visible' : 'hidden',
              ]"
              @click="navigateToReserve"
            >
              <card class="shadow-lg--hover card-product">
                <b-col cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
                  <div class="img-product">
                    <img src="img/product/research-rafiki.svg" />
                  </div>
                </b-col>
                <b-col cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
                  <div class="text-product">
                    <h5>مدیریت رزرو و نوبت دهی</h5>
                    <span>
                      راهکاری ساده و کارآمد برای مدیریت نوبت دهی و رزروهای کسب و
                      کار شما
                    </span>
                    <p @click="navigateToReserve">مشاهده بیشتر</p>
                  </div>
                </b-col>
              </card>
            </b-col>
            <b-col
              cols="12"
              xl="4"
              lg="6"
              md="6"
              sm="12"
              xs="12"
              :class="[
                'box-card-product',
                cardVisible[5] ? 'visible' : 'hidden',
              ]"
              @click="navigateToOnlion"
            >
              <card class="shadow-lg--hover card-product">
                <b-col cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
                  <div class="img-product">
                    <img src="img/product/shopping-bro.svg" />
                  </div>
                </b-col>
                <b-col cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
                  <div class="text-product">
                    <h5>مدیریت فروشگاه آنلاین و فیزیکی</h5>
                    <span>
                      در دنیای دیجیتال امروز، راه‌اندازی یک فروشگاه آنلاین موفق
                      می‌تواند تحولی بزرگ در کسب‌وکار شما ایجاد کند. نرم‌افزار
                      فروشگاه آنلاین سرمد، ابزاری جامع و کاربرپسند است که به شما
                      امکان می‌دهد تا به‌ آسانی فروشگاه اینترنتی خود را ایجاد و
                      مدیریت کنید و تجربه‌ای بی‌نظیر برای مشتریان خود فراهم
                      آورید.
                    </span>
                    <p @click="navigateToOnlion">مشاهده بیشتر</p>
                  </div>
                </b-col>
              </card>
            </b-col>
            <b-col
              cols="12"
              xl="4"
              lg="6"
              md="6"
              sm="12"
              xs="12"
              :class="[
                'box-card-product',
                cardVisible[6] ? 'visible' : 'hidden',
              ]"
              @click="navigateToScient"
            >
              <card class="shadow-lg--hover card-product">
                <b-col cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
                  <div class="img-product">
                    <img src="img/product/lab-cuate.svg" />
                  </div>
                </b-col>
                <b-col cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
                  <div class="text-product">
                    <h5>سامانه علم سنجی (Scientometrics)</h5>
                    <span>
                      نرم ‌افزار علم‌سنجی سرمد ابزاری دقیق است که برای تحلیل و
                      ارزیابی داده‌های علمی و پژوهشی به کار می‌رود. این نرم
                      ‌افزار به کاربران کمک می‌کند تا روندها، الگوها و تاثیرات
                      تحقیقاتی را شناسایی و بررسی کنند و کاربردهای گسترده‌ای در
                      دانشگاه‌ها، مؤسسات تحقیقاتی و شرکت‌های دانش بنیان دارد.
                    </span>
                    <p @click="navigateToScient">مشاهده بیشتر</p>
                  </div>
                </b-col>
              </card>
            </b-col>
          </b-row>
        </div>
      </div>
    </section>
    <button v-if="showScrollButton" @click="scrollToTop" class="scroll-to-top">
      <i class="fa fa-arrow-up" aria-hidden="true"></i>
    </button>
  </div>
</template>
<script>
export default {
  name: "Products",
  components: {},
  data() {
    return {
      showScrollButton: false,
      cardVisible: [false, false, false, false, false, false, false],
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    handleScroll() {
      this.showScrollButton = window.scrollY > 300;
    },
    scrollToProduct() {
      const productSection = this.$refs.productSection;
      if (productSection) {
        productSection.scrollIntoView({ behavior: "smooth" });
      }
    },
    animateCards() {
      this.cardVisible.forEach((_, index) => {
        setTimeout(() => {
          this.$set(this.cardVisible, index, true);
        }, index * 1000);
      });
    },
    navigateToSatrapp() {
      this.$router.push("/satrapp");
    },
    navigateToCrm() {
      this.$router.push("/crm");
    },
    navigateToLMS() {
      this.$router.push("/satrapp-lms");
    },
    navigateToTotia() {
      this.$router.push("/totiateb");
    },
    navigateToReserve() {
      this.$router.push("/reservation");
    },
    navigateToOnlion() {
      this.$router.push("/onlion");
    },
    navigateToScient() {
      this.$router.push("/scientometrics");
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    this.animateCards();
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style lang="scss">
.box-card-product {
  cursor: pointer;
}
.hidden {
  opacity: 0;
  transform: translateX(100%);
  transition: opacity 1s ease, transform 1s ease;
}

.visible {
  opacity: 1;
  transform: translateX(0);
  transition: opacity 1s ease, transform 1s ease;
}
</style>
